// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const DomainSourceSchema = z.enum(['USER_PROVIDED','EXTENSION','HEADLESS_BROWSER','CRAWLER','PROXY'] as const);

export type DomainSourceType = `${z.infer<typeof DomainSourceSchema>}`

export default DomainSourceSchema;
